module.exports = __webpack_public_path__ + "static/media/cat11.f9312641.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat11.jpeg
// module id = 43
// module chunks = 0